import {
  withCompInfo,
  createComponentMapperModel,
  withStateRefsValues,
} from '@wix/editor-elements-integrations';

import type {
  TextOnPathDefinition,
  TextOnPathProps,
} from '../TextOnPath.types';
import { TranslationKeys } from './constants';

export const props = withCompInfo<TextOnPathProps, TextOnPathDefinition>()(
  ['compId', 'compData', 'translate'],
  ({ compData, compId, translate }) => {
    return {
      ...compData,
      id: compId,
      translations: {
        pauseLabel: translate(
          TranslationKeys.namespace,
          TranslationKeys.pauseLabel,
        ),
        playLabel: translate(
          TranslationKeys.namespace,
          TranslationKeys.playLabel,
        ),
      },
    };
  },
);

export const stateRefs = withStateRefsValues(['reducedMotion']);

export default createComponentMapperModel({
  props,
  stateRefs,
});
